// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { postingPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
export default {
  postingAction: async ({ rootState, dispatch }, { postingData, permission }) => {
    try {
      const userId = rootState.auth.userData.id
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/postingsweb/api/Posting/v1', postingData)
      await dispatch('account/getTillAccountBalance', { userId }, { root: true })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  chequeDepositAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.OUTWARD_CHEQUE_DEPOSIT_POSTING)
      const response = await axiosIns.post('/postingsweb/api/ChequeDeposit/v1', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  reversalAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.REVERSAL_POSTING)
      const response = await axiosIns.post('/postingsweb/api/Reversal/v1', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  cancelPostingAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.CANCEL_POSTING)
      const response = await axiosIns.post('/postingsweb/api/Reversal/v1/Cancel', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateBatchGlPostingCreation: async (context, formData) => {
    try {
      useJwt.setPermission(formData.permission)
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/ValidateBatchUpload', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postingBatchPostingAction: async (context, data) => {
    try {
      useJwt.setPermission(data.permission)
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/BatchUpload', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  reversalBatchTransactionPosting: async (context, data) => {
    try {
      const response = await axiosIns.post('/postingsweb/api/Reversal/v1/BatchReverse', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  accountClosureAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.ACCOUNT_CLOSURE_POSTING)
      const response = await axiosIns.post('/postingsweb/api/AccountClosure/v1', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fixedDepositLiquidate: async (context, data) => {
    try {
      useJwt.setPermission('LIQUIDATE_FIXED_DEPOSIT_ACCOUNT')
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/LiquidateFixedDeposit', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fixedDepositTopup: async (context, data) => {
    try {
      useJwt.setPermission('FIXED_DEPOSIT_TOP_UP')
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/FixedDepositTopUp', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  clearChequeAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.VIEW_LOCAL_CHEQUE_DEPOSIT_POSTING)
      const response = await axiosIns.post('/postings/api/ChequeDeposit/v1/Clear', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  returnChequeAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.VIEW_LOCAL_CHEQUE_DEPOSIT_POSTING)
      const response = await axiosIns.post('/postings/api/ChequeDeposit/v1/Return', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postingBackdatingAction: async (context, data) => {
    try {
      useJwt.setPermission(postingPermissions.BACKDATING_POSTING)
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/BackdatePost', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postEndOfYearClosureAction: async (context, { postingData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/postingsweb/api/Posting/v1/EOYBackdatePost', postingData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  recomputeLoanStatusAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/postings/api/Posting/v1/RecomputeLoanPastDueAsync', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
